
function loadScriptBody (trackerScript, async = true, elementId = null) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = trackerScript
    script.async = async
    if (elementId) {
      script.id = elementId
    }

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
    script.onload = resolve
    script.onerror = reject
  })
}

export function objectExist (name) {
  return new Promise((resolve) => {
    const checkInterval = 50
    const timeout = 3000
    const waitStart = Date.now()
    const interval = setInterval(() => {
      if (window[name]) {
        clearInterval(interval)
        return resolve()
      }
      if (Date.now() >= waitStart + timeout) {
        clearInterval(interval)
        throw new Error(`window.${name} undefined after waiting for ${timeout}ms`)
      }
    }, checkInterval)
  })
}

function mutationsWatcher (mutation, state) {
  if (!window.mt) {
    return
  }
  if (mutation.type.startsWith('filtering')) {
    window.mt('send', 'pageview', { page_title: `${mutation.type} ${mutation.payload}` })
  }
  if (mutation.type.startsWith('favourites/') && !mutation.type.endsWith('concatFavourites')) {
    window.mt('send', 'pageview', { page_title: `${mutation.type} ${mutation.payload.slide}` })
  }
}

function actionsWatcher (action, store) {
  if (!window.mt) {
    return
  }

  if (action.type === 'buy/download') {
    window.mt('send', 'pageview', { page_title: `${action.type} ${action.payload.slide.title}` })
  } else if (action.type === 'buy/buySlide') {
    const slide = store.buy.slide
    window.mt('send', 'pageview', { page_title: `${action.type} ${slide.value} ${slide.title}` })
  }
}

export default function install (Vue, setupOptions = {}) {
  const trackerScript = setupOptions.trackerScript || 'https://clients.infodiagram.com/mtc.js'
  const router = setupOptions.router
  const store = setupOptions.store
  window.MauticTrackingObject = 'mt'
  window.mt = window.mt || function () { (window.mt.q = window.mt.q || []).push(arguments) }
  loadScriptBody(trackerScript)
    .then(() => objectExist('MauticJS'))
    .then(() => {
      window.mt('send', 'pageview')
      Vue.prototype.$mautic = window.mt
      if (router) {
        router.afterEach(() => {
          // wait until router has resolved possible async components and hooks
          setTimeout(() => {
            window.mt('send', 'pageview')
          }, 1000)
        })
      }
      if (store) {
        store.subscribe(mutationsWatcher)
        store.subscribeAction(actionsWatcher)
      }
    })
}

export function getMauticContactId () {
  try {
    return localStorage.getItem('mtc_id')
  } catch (e) {
    return null
  }
}
